/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryProfilesEditViewController(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                            $location: JS5Object, PartnerEditService: JS5Object, uiGridConstants: JS5Object,
                                            ModalService: JS5Object, NotificationService: JS5Object,
                                            MediaAcceptProfileService: JS5Object, BreadcrumbService: JS5Object) {


    this.activeTabs = {
        properties: false,
        emails: false,
        deliveryItems: false
    };
    this.enabledTabs = {
        properties: true,
        emails: $routeParams.deliveryProfileId !== '-1',
        deliveryItems: $routeParams.deliveryProfileId !== '-1'
    };

    //Tab Functionality
    this.onTabSelect = (tab: string) => {
        this.currentTab = tab;
        $location.search('tab', tab);
    };

    const setupBreadcrumbs = () => {
        if (_.size(BreadcrumbService.getBreadcrumbs()) === 0) {
            BreadcrumbService.addBreadcrumb({
                name: 'Partners',
                location: `/system/partners`,
                params: null
            });
            BreadcrumbService.addBreadcrumb({
                name: this.partnerName,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles`
            });
        } else if (_.size(BreadcrumbService.getBreadcrumbs()) === 1) {
            BreadcrumbService.addBreadcrumb({
                name: this.partnerName,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles`
            });
        }
    };

    this.$onInit = () => {
        this.currentTab = $location.search().tab;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        setupBreadcrumbs();
    };
}


angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/delivery-profiles-edit-view-template.html',
    controller: DeliveryProfilesEditViewController,
    bindings: {
        partnerName: '<'
    }
});
